import * as React from 'react'
import { Button } from 'antd'
import { THEME_COLORS } from '@getgreenline/shared'
import { UBER_EATS_ACCEPT_COLOR } from '../../constants/UberEats'

type Variant = 'accept' | 'confirm' | 'neutral' | 'link'

interface Props {
  title: string
  onClick: () => void
  variant?: Variant
  disabled?: boolean
  testId?: string
}

const { BRAND, MONO } = THEME_COLORS

const VARIANT_STYLES: Record<Variant, React.CSSProperties> = {
  accept: {
    backgroundColor: UBER_EATS_ACCEPT_COLOR,
    borderColor: UBER_EATS_ACCEPT_COLOR,
    color: BRAND.black,
    fontWeight: 600,
  },
  confirm: {
    backgroundColor: BRAND.black,
    borderColor: BRAND.black,
    color: MONO.monoFf,
    fontWeight: 600,
  },
  neutral: { color: BRAND.black, fontWeight: 600 },
  link: { color: BRAND.black, fontWeight: 600, textDecoration: 'underline' },
}

export const UberEatsActionButton = ({
  title,
  onClick,
  variant = 'neutral',
  disabled = false,
  testId,
}: Props) => (
  <Button
    data-testid={testId}
    type={variant === 'link' ? 'link' : 'default'}
    disabled={disabled}
    onClick={onClick}
    style={disabled ? undefined : VARIANT_STYLES[variant]}
  >
    {title}
  </Button>
)
